import type React from "react"

export const OzIcon = (props: React.ComponentProps<"svg">): JSX.Element => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            fill='none'
            viewBox='0 0 24 24'
            {...props}
        >
            <g fill='currentColor' fillRule='evenodd' clipRule='evenodd'>
                <path d='M12 2a1 1 0 01.858.485c.691 1.154 1.384 2.237 2.046 3.273l.142.222c.701 1.098 1.37 2.15 1.946 3.155C18.13 11.117 19 13.063 19 15a7 7 0 11-14 0c0-1.937.87-3.883 2.008-5.865.576-1.005 1.245-2.057 1.946-3.155l.142-.222c.662-1.036 1.355-2.12 2.046-3.273A1 1 0 0112 2zm-3.258 8.13C7.63 12.07 7 13.623 7 15a5 5 0 0010 0c0-1.377-.63-2.93-1.742-4.87-.55-.957-1.193-1.97-1.898-3.073l-.144-.226c-.392-.613-.8-1.253-1.216-1.918-.415.665-.824 1.305-1.216 1.918l-.144.226C9.935 8.16 9.29 9.173 8.742 10.13z'></path>
                <path d='M14 14a1 1 0 011 1 3 3 0 01-3 3 1 1 0 110-2c.552 0 1-.448 1-1s.448-1 1-1z'></path>
            </g>
        </svg>
    )
}
